import { useState } from "react";
import { useRecoilValue } from 'recoil';
import { isIbarakiAgFlag } from 'atoms/projectData';

// 解析点の大きさを変更する処理
export const useConfigAnalysisPointSize = (debugFlag) => {
  const ibarakiAgFlag = useRecoilValue(isIbarakiAgFlag);  

  let defaultPointSize;
  defaultPointSize = debugFlag ? 1.53 : 1.81; // デフォルトの解析点の大きさ
  if(ibarakiAgFlag) defaultPointSize = 1.53

  const [analysisPointSize, setAnalysisPointSize] = useState(defaultPointSize); // 解析点の大きさを定義
  
  // // 解析点の変更(セレクトボックス)が行われた際の処理
  const handleChangeAnalysisPointSize = (e) => {
    setAnalysisPointSize(Number(e.target.value));
  }

  return {
    analysisPointSize,
    handleChangeAnalysisPointSize
  };
};
